const services = [
  {
    icon: "icon-basic-message-multiple",
    title: "Your orders are getting lost in WhatsApp chats",
    text: "Customers message. You reply late. Orders get missed. Every chat feels like a risk.",
  },
  {
    icon: "icon-basic-webpage-img-txt",
    title: "You don’t have a proper website",
    text: "People check your Instagram… but then leave. No website = no trust = lost customers.",
  },
  {
    icon: "icon-basic-magnifier",
    title: "Your competitors show up on Google. You don’t.",
    text: "Customers are searching daily. If you’re not there, they’re buying from someone else.",
  },
  {
    icon: "icon-ecommerce-wallet",
    title: "Payments are messy and hard to track",
    text: "UPI screenshots, missed confirmations, awkward follow-ups. It’s exhausting.",
  },
  {
    icon: "icon-ecommerce-bag-check",
    title: "Inventory is always confusing",
    text: "You oversell. Or run out. Or spend hours figuring out what’s left.",
  },
  {
    icon: "icon-basic-mail-open-text",
    title: "Customers don’t come back",
    text: "No system = no data. Every sale feels like starting from zero again.",
  },
];

const ProblemSection = () => {
  return (
    <section id="problems" className="ptb ptb-sm-80 services-section-spacing">
      <div className="container text-center">
        <h3>
          z You’ve built a real business.
          <br />
          But running it on WhatsApp, it’s costing you sales
          <span style={{ color: "#e6ae49" }}>.</span>
        </h3>

        <p className="lead" style={{ maxWidth: "700px", margin: "0 auto" }}>
          If this feels familiar, you’re not alone. Most small businesses
          struggle here - until they fix their system.
        </p>

        <div className="spacer-60" />

        <div className="row">
          {services.map((service) => (
            <div className="col-md-6 col-sm-6 mb-45" key={service.title}>
              {/* ICON SAME */}
              <div className="page-icon-top">
                <i className={`icon ${service.icon}`} aria-hidden="true" />
              </div>

              <h5 style={{ marginBottom: "10px" }}>{service.title}</h5>
              <p style={{ fontSize: "14px", opacity: 0.9 }}>{service.text}</p>
            </div>
          ))}
        </div>

        {/* Punch line */}
        <p style={{ marginTop: "30px", fontSize: 18, fontWeight: "500" }}>
          The problem is not your product.
          <br />
          It’s the system you’re using.
        </p>
      </div>
    </section>
  );
};

export default ProblemSection;
